var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    { staticClass: "navbar", attrs: { mode: "horizontal" } },
    [
      _c(
        "div",
        { staticClass: "grid-wrapper" },
        [
          _c("div", { staticClass: "hearlogo" }, [
            _c(
              "div",
              { staticClass: "avatar-container" },
              [
                _c(
                  "el-image",
                  {
                    staticClass: "user-avatar",
                    attrs: { src: _vm.logo_icon, fit: "contain" }
                  },
                  [
                    _c("div", {
                      staticClass: "image-slot",
                      attrs: { slot: "error" },
                      slot: "error"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-container" }, [
              _c("span", { staticClass: "main-name" }, [
                _c("span", { staticClass: "main-name1" }, [
                  _vm._v(_vm._s(_vm.empname))
                ]),
                _c("span", { staticClass: "main-name2" })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("span"),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.gbDialogVisible,
                title: "留言板",
                width: "30%",
                "append-to-body": true
              },
              on: {
                "update:visible": function($event) {
                  _vm.gbDialogVisible = $event
                }
              }
            },
            [_c("GuestBook")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nav-right" },
            [
              _c("qr-code"),
              _vm._v(" "),
              _c("el-button", {
                staticStyle: { "margin-left": "15px" },
                attrs: {
                  type: "success",
                  icon: "el-icon-edit-outline",
                  circle: true,
                  title: "留言板"
                },
                on: {
                  click: function($event) {
                    _vm.gbDialogVisible = true
                  }
                }
              }),
              _vm._v(" "),
              _c("MessageList"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "principal-wrapper" },
                [
                  _c("div", { staticClass: "user-info" }, [
                    _c(
                      "div",
                      { staticClass: "avatar-wrapper" },
                      [
                        _c("svg-icon", {
                          staticClass: "user-avatar",
                          attrs: { "icon-class": "user" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "user" }, [
                      _c("div", { staticClass: "phone" }, [
                        _vm._v(_vm._s(_vm.phone))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.name))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown",
                    { attrs: { trigger: "click" } },
                    [
                      _c("div", { staticClass: "more" }, [
                        _c("i", {
                          staticClass: "more-icon el-icon-caret-bottom"
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        {
                          staticClass: "user-dropdown",
                          attrs: { slot: "dropdown" },
                          slot: "dropdown"
                        },
                        [
                          _c(
                            "router-link",
                            { staticClass: "inlineBlock", attrs: { to: "/" } },
                            [_c("el-dropdown-item", [_vm._v("首页")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-dropdown-item", { attrs: { divided: "" } }, [
                            _c(
                              "span",
                              {
                                staticStyle: { display: "block" },
                                on: { click: _vm.updatePassWord }
                              },
                              [_vm._v("修改密码")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("el-dropdown-item", { attrs: { divided: "" } }, [
                            _c(
                              "span",
                              {
                                staticStyle: { display: "block" },
                                on: { click: _vm.logout }
                              },
                              [_vm._v("退出")]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showpub
        ? [_c("PassWord", { on: { cancel: _vm.closewindow } })]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-797e31be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-797e31be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Navbar.vue
// module id = null
// module chunks = 